import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import FrontendLayout from '@/layouts/frontend/layouts';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';

type PageWithLayout = React.ComponentType & {
    layout?: (page: ReactNode) => ReactNode;
};

createInertiaApp({
    resolve: async (name) => {
        const pages = import.meta.glob('./pages/**/*.tsx') as Record<
            string,
            () => Promise<{ default: PageWithLayout }>
        >;

        const path = `./pages/${name}.tsx`;

        const page = await pages[path]();

        if (!page) {
            throw new Error(`Page not found: ${name}`);
        }

        const pageComponent = page.default as PageWithLayout;

        pageComponent.layout = (pageEl: React.ReactNode) => (
            <FrontendLayout>{pageEl}</FrontendLayout>
        );

        return pageComponent;
    },

    setup({ el, App, props }) {
        createRoot(el).render(
            <TooltipProvider delayDuration={0}>
                <App {...props} />
            </TooltipProvider>
        );
    },

    progress: {
        color: '#E3901C',
    },
});

